import { App } from 'app/App'
import { startup } from 'app/config/startup'
import 'app/css/index.scss'
import { configureAntd } from 'app/Theme'
import 'design/irnby/css/index.scss'
import 'design/tsum/css/index.scss'
import 'design/sela/css/index.scss'
import { when } from 'mobx'
import { createRoot } from 'react-dom/client'
import { store } from 'store/store'

startup()

const container = document.getElementById('root')!
configureAntd(container)

when(() => store.init || !!store.error, () => {
  const root = createRoot(container)
  root.render(<App />)
})
